module.exports = __webpack_public_path__ + "static/media/accepted_active.78bb30cb.svg";